/**
 * ResetPasswordPage.tsx - Password Reset Page
 */

import { ResetPassword } from '@/ui/views/authentication/ResetPassword'

export const ResetPasswordPage = () => {
    return (
        <>
            <ResetPassword />
        </>
    )
}
